import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RealEstateService {

  domain = environment.ENDPOINT
  constructor(private httpClient: HttpClient) { }

  GETALL(): Observable<any[]> {
    return this.httpClient.get<any[]>(`${this.domain}/api/realestate`,
      {
        headers: { "Authorization": environment.Authorization.readOnly }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  SEARCH(body: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.domain}/api/realestate/search`, body,
      {
        headers: { "Authorization": environment.Authorization.readOnly }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  CREATE(body: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.domain}/api/realestate`, body,
      {
        headers: { "Authorization": environment.Authorization.create }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  UPDATE(body: any, id: any): Observable<any[]> {
    return this.httpClient.put<any[]>(`${this.domain}/api/realestate/${id}`, body,
      {
        headers: { "Authorization": environment.Authorization.edit }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  DELETE(id: any): Observable<any[]> {
    return this.httpClient.delete<any[]>(`${this.domain}/api/realestate/${id}`,
      {
        headers: { "Authorization": environment.Authorization.edit }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }

  getUser(body: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.domain}/api/users/queries`, body,
      {
        headers: { "Authorization": environment.Authorization.readOnly }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  getAuth(body: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.domain}/api/users/login`, body,
      {
        headers: { "Authorization": environment.Authorization.edit }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
  registerUser(body: any): Observable<any[]> {
    return this.httpClient.post<any[]>(`${this.domain}/api/users`, body,
      {
        headers: { "Authorization": environment.Authorization.create }
      }).pipe(
        tap({ next: (data) => data, error: (error) => error })
      );
  }
}
